<template>
  <div class="boxHeader">
    <div class="header">
      <div class="headerLeft">
        <img src="@/assets/logo/logo.png" alt="" class="logo">
        <span>八角游戏</span>
      </div>
      <div class="headerCenter">
        <el-input type="text" v-model="search" size="small" ></el-input>
        <el-button type="primary" style="border-radius: 4px !important;margin-left: 7px;border: 0;" size="small" @click="searchEvent">搜索</el-button>
        <el-button type="primary" style="border-radius: 4px !important;margin-left: 7px;background-color: #555;color:#fff;border: 0;" size="small"  @click="openVip">开通会员</el-button>
      </div>
      <div class="headerRight">
        <div class="userInfo" v-if="userInfo">
          <span style="font-size: 12px;">你好,<span style="color: green;">{{userInfo.user}}</span>,会员到期时间: <span :style="{color:!isVip?'red':'orange'}">{{isVip?formatDate(userInfo.end_time*1000):`未办理`}}</span>
          </span>
          <span @click="logout" style="color:#2c3e50;font-size: 12px;margin-left: 5px;">退出登录</span>
        </div>
        <el-button type="primary" @click="openLogin" size="small" v-if="!userInfo">登录</el-button>
        <el-button type="primary" @click="openResgister" size="small" v-if="!userInfo">注册</el-button>
      </div>
    </div>
    <login v-if="loginShow" @closeLogin="closeLogin" @openRegister="openResgister"></login>
    <register v-if="registerShow" @closeLogin="closeRegister" @openRegister="openResgister" @openLogin="openLogin"></register>
    <openvip v-if="openVipShow" @closeVip="closeVip"></openvip>
  </div>
</template>
<script>
  import login from "@/components/qt/login.vue";
  import register from "@/components/qt/register.vue";
  import openvip from "@/components/openvip/index.vue";
  import {getUserInfo} from "@/api/qt/common";
  import {getGameListByKeyWord} from "@/api/qt/common";
  import {Message} from "element-ui";

  export default {
    components:{
      login,
      openvip,
      register
    },
    data(){
      return {
        search:"",
        loginShow:false,
        registerShow:false,
        userInfo:undefined,
        openVipShow:false,
      }
    },
    created() {
      //检测是否为pc端
      let b=this.isPC()
      if(!b){
        window.location.href="https://mobile.bajiaoyouxi.cn";
      }
      this.getMyInfo();
    },
    computed:{
      isVip(){
        return new Date(this.userInfo.end_time*1000).getTime()>new Date().getTime();
      }
    },
    methods:{
      isPC() {
        const userAgent = navigator.userAgent.toLowerCase();
        const mobileAgents = [
          'android', 'iphone', 'symbianos', 'windows phone',
          'ipad', 'ipod', 'blackberry', 'mobile'
        ];
        console.log(userAgent,'userAgent')
        // alert(userAgent)
        // 如果包含移动设备关键词，则不是PC
        return !mobileAgents.some(agent => userAgent.indexOf(agent)==-1?false:true);
      },
      formatDate(time){
        if(time>4867200000000){
          return '永久会员';
        }
        let date=new Date(time);
        return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
      },
      closeVip(){
        this.openVipShow=false;

      },
      openVip(){
        let token=localStorage.getItem("token")
        this.openVipShow=true;
      },
      searchEvent($event,pageNum=1){
        if(this.$route.name=='index' || this.$route.name=='detail'){
          localStorage.setItem('keyword',this.search)
          setTimeout(()=>{
            localStorage.removeItem('keyword');
          },2000)
          setTimeout(()=>{
            this.$router.push({path:"/gameList",query:{keyword:this.search}})

          },10)
        }else{
          this.$emit("setLastSearchType","search")
          getGameListByKeyWord(this.search,pageNum).then((res)=>{
            let data=res.data.data.data
            this.$emit("setGameList",data);
          })
        }

      },
      getMyInfo(){
        getUserInfo(localStorage.getItem("token")).then((res)=>{
          console.log(res.data,"获取用户信息")
          let userInfo = res.data.data;
          this.userInfo = userInfo;
        })
      },
      logout(){
        this.userInfo=undefined;
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token")
      },
      closeRegister(){
        this.registerShow=false;
      },
      closeLogin(){
        this.loginShow=false;
      },
      openResgister(){
        this.registerShow=true;
      },
      openLogin(){
        this.loginShow=true;
      }
    }
  }
</script>
<style scoped>

.userInfo{
  display: flex;
  align-items: center;
}
  .header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding: 7px 7px;
    box-sizing: border-box;
    position: relative;
  }
  .headerCenter{
    display: flex;
    align-items: center;

  }
  .logo{
    height:40px;

  }
  .headerLeft{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  /* 去掉圆角 */
  .headerCenter .el-input__inner {
    border-radius: 0 !important;
  }
  .headerLeft > span{
    font-size: 12px;
    color:#aaa;
  }
  .headerCenter *{
    border-radius: 0 !important;
  }
  .headerRight{
  }
</style>
